import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import palette from '../../lib/styles/palette';

const TabBlock = styled.div`
  border-bottom: 1px solid hsla(0, 0%, 0%, 0.08);
  margin-bottom: 25px;
  ${(props) =>
    props.underbar &&
    css`
      border-bottom: 1px solid hsla(0, 0%, 0%, 0.08);
    `}
`;

const StyledUl = styled.ul`
  display: flex;
  justify-content: space-between;
  z-index: 25;
  padding-bottom: 2rem;
  padding-top: 2rem;
`;

const Tab = styled(NavLink)`
  cursor: pointer;
  color: inherit;
  font-size: 1.3rem;
  &:hover {
    color: #495057;
  }

  &.active {
    font-weight: bold;
    color: ${palette.webCyan[5]};
    &:hover {
      color: #3bc9db;
    }
  }
`;

// const DevelopingTab = styled.div`
//   cursor: pointer;
//   color: inherit;
//   font-size: 1.3rem;
//   &:hover {
//     color: #495057;
//   }

//   &.active {
//     font-weight: bold;
//     color: ${palette.webCyan[5]};
//     &:hover {
//       color: #3bc9db;
//     }
//   }
// `;
const TabMenu = ({ history, underbar }) => {
  const { club } = useSelector(({ club }) => ({
    club: club.defaultClub,
  }));

  return (
    <TabBlock underbar={underbar}>
      <StyledUl>
        <li>
          <Tab to="/configuration/item">상품 관리</Tab>
        </li>
        <li>
          <Tab to="/configuration/coach">강사 관리</Tab>
        </li>
        <li>
          <Tab to="/configuration/econtract">전자계약서 관리</Tab>
        </li>
        <li>
          <Tab to="/configuration/door">출입문 관리</Tab>
        </li>
        <li>
          <Tab to={'/configuration/center'}>클럽 관리</Tab>
        </li>
        {club && club.attendAppActive === 1 &&
        <li>
          <Tab to={'/configuration/attendapp'}>출석앱</Tab>
        </li>
        }
        {/* 바코드 스캐너 관리 탭 — 잠정 숨김(소스 유지). 관리는 admin 클럽설정 > 바코드 스캔모드에서.
        <li>
          <Tab to="/configuration/barcode">바코드 스캐너 관리</Tab>
        </li>
        */}
        <div style={{width: '40%'}}/>
        {/* <li>
          <DevelopingTab onClick={() => alert('개발중인 메뉴입니다')}>
            메뉴 관리
          </DevelopingTab>
        </li> */}
      </StyledUl>
    </TabBlock>
  );
};

export default withRouter(TabMenu);
